import React from "react";
import "./table.scss";
import { PropTypes } from "prop-types";

export const TableCompare = ({
  data,
  hideSeats,
  isSenate,
  isCouncilor,
  showPerson,
  details,
  legend
}) => {
  return (
    <div className="table-datosContainer">
      <div className="table-datosScroll">
        <div className="table-wrapper">
          {data.length !== 0 && (
            <table
              summary={
                isSenate ? "Senadores por partido" : "Escaños por partido."
              }
            >
              <thead>
                <tr>
                  <th className="partido">
                    {!showPerson ? "Partido" : "Representante"}
                  </th>
                  {!hideSeats && (
                    <th className="escanos">
                      {isSenate
                        ? "Senadores"
                        : isCouncilor
                        ? "Concejales"
                        : "Escaños"}
                    </th>
                  )}
                  {details && <th className="porcentaje">%</th>}
                  {details && <th className="votos">Votos</th>}
                </tr>
              </thead>
              <tbody>
                {data
                  .filter(item => {
                    return item.seats > 0 || (details && item.votes > 0);
                  }) // TODO REVISAR
                  .map(item => (
                    <tr key={item.name || item.partyAcronym || item.id}>
                      <td className="dato-nombre-partido">
                        <span
                          style={{
                            borderLeft: `5px solid ${item.partyColor}`
                          }}
                        >
                          <span className="partido">
                            {!showPerson
                              ? item.partyAcronym
                              : `${item.name} (${item.partyAcronym})`}
                          </span>
                        </span>
                      </td>
                      {!hideSeats && (
                        <td className="dato-escanos">{item.seats}</td>
                      )}
                      {details && (
                        <td className="dato-escanos">
                          {Number(item.votesPercent).toLocaleString("es")}
                        </td>
                      )}
                      {details && (
                        <td className="dato-escanos_votes">
                          {Number(item.votes).toLocaleString("de")}
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="legendContainer">
        {legend &&
          legend.map(legendItem => (
            <p key={legendItem} className="table-datosLegend">
              {legendItem}
            </p>
          ))}
      </div>
    </div>
  );
};

TableCompare.propTypes = {
  // eslint-disable-next-line
  data: PropTypes.array.isRequired,
  hideSeats: PropTypes.bool,
  isSenate: PropTypes.bool,
  isCouncilor: PropTypes.bool
};

TableCompare.defaultProps = {
  hideSeats: false,
  isSenate: false,
  isCouncilor: false,
  legend: undefined
};

export default TableCompare;
